import { useEffect } from "react";

const useTitle = (title) => {
    useEffect(() => {
        document.title = title || "Yeetch";
    }, [title]);
};

export default useTitle;
